import { normalize, schema } from 'normalizr';
import { createMemberSchema } from '../../../models/member/member.schema';
import {
  IApiPhotoRequestsResult,
  photoRequestSchema,
} from '../../../models/photoRequests';
import { pictureSchema } from '../../../models/picture';
import { memberInPhotoPrivacySerializer } from '../helper';

const photoRequestsSchema = new schema.Object({
  data: [photoRequestSchema],
  included: new schema.Array(
    {
      member: createMemberSchema(memberInPhotoPrivacySerializer),
      mainPicture: pictureSchema,
    },
    'type'
  ),
});

export const photoRequestsNormalizer = (
  photoRequest: IApiPhotoRequestsResult
) => normalize(photoRequest, photoRequestsSchema);
